// Profile.jsx
import { useState } from "react";
import DashboardLayout from "../common/DashboardApp";
import ProfileHeader from "./ProfileHeader";
import EditProfile from "./EditProfile";
import Education from "./Education";
import Skill from "./Skill";
import WorkExperience from "./WorkExperience";
import Resume from "./Resume";
import HourleeResume from "./HourleeResume";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("profile"); // default

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <ProfileHeader activeTab={activeTab} setActiveTab={setActiveTab} />

          {activeTab === "profile" && <EditProfile />}
          {activeTab === "education" && <Education />}
          {activeTab === "skill" && <Skill />}
          {activeTab === "work" && <WorkExperience />}
          {activeTab === "resume" && <Resume />}
          {activeTab === "hourleeresume" && <HourleeResume />}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Profile;